import React, { Component } from "react";
import axios from "services/axios";
import moment from "moment";
import {  Tag, Divider } from "antd";
import BigCalendar from 'react-big-calendar-like-google';
import 'react-big-calendar-like-google/lib/css/react-big-calendar.css';

import { ModalDetailBooking } from "../ModalBooking";
BigCalendar.momentLocalizer(moment);

class CalendarBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookingList: [],
      activeMonth: new Date().getMonth(),
      showModalDetail: false,
      detailBooking: {},
    };
    this.toggleModalDetail = this.toggleModalDetail.bind(this);
  }

  componentDidMount() {
    this.fetchBooking();
  }

  fetchBooking() {
    axios
      .get("/booking")
      .then(result => {
        this.setState({
          ...result.data,
          bookingList: this.parseListBooking(result.data.booking),
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  toggleModalDetail(bool) {
    this.setState({
      showModalDetail: bool,
    });
  }

  onClickDetailBooking(record) {
    this.setState({
      showModalDetail: true,
      detailBooking: record,
    });
  }

  parseListBooking(bookingArr) {
    let bookingList = [];
    bookingArr.forEach(booking => {
      let objBooking = {};
      objBooking.title = `${moment(booking.bookingTime, "YYYY-MM-DDTHH:mm").format("HH:mm")} - ${booking.Appraiser ? booking.Appraiser.name : "unassigned"}`;
      objBooking.bgColor = booking.Appraiser ? "#13c2c2" : "#f5222d";
      // objBooking.allDay = true;
      objBooking.start = new Date(moment(booking.bookingTime, "YYYY-MM-DDTHH:mm"))
      objBooking.end = new Date(moment(booking.bookingTime, "YYYY-MM-DDTHH:mm"))
      objBooking.detail = booking
      bookingList.push(objBooking)
    });
    return bookingList;
  }

  render() {
    return (
      <div
        style={{
          padding: 24,
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}
      >

        <BigCalendar
          {...this.props}
          selectable
          events={this.state.bookingList}
          defaultDate={new Date()}
          onSelectEvent={event => this.onClickDetailBooking(event.detail)}
        />

        <ModalDetailBooking
          showModalDetail={this.state.showModalDetail}
          dataBooking={this.state.detailBooking}
          toggleModalDetail={this.toggleModalDetail}
        />

        <div style={{ width: 400 }}>
          <Divider orientation="left">Notes</Divider>
          <Tag color="cyan">Assigned</Tag>
          <Tag color="red">Unassigned</Tag>
        </div>
      </div>
    );
  }
}

export default CalendarBooking;



// WEBPACK FOOTER //
// src/components/Dashboard/Calendar/Calendar.js